<template>
  <div class="input-tool-container" id="input-tool-container">
    <!-- 欢迎 -->
    <div v-if="inputType === 'hello'">
      <van-button
        class="btn"
        style="color: #fff; background: #1edf41"
        block
        @click="helloClick"
        :loading="sendBtnLoading"
        :disabled="isDisabledBtn"
        v-track-event="{
          category: 'button',
          action: 'click',
          opt_label: '你好'
        }"
      >
        <div class="hx-flex-c-c">
          你好

          <!-- <div
            class="my-icon-img"
            :style="{
              fontSize: '1.4em',
              marginLeft: '4px',
              backgroundImage: `url(${require('/src/assets/icon/dj.png')})`,
            }"
          ></div> -->
        </div>
      </van-button>
      <!-- <div
        class="btn"
        @click="
          () => {
            $emit('playVideo');
            inputType = 'voice';
          }
        "
      >
        你好<van-icon style="color: #1edf41; padding-left: 4px" name="bell" />
      </div> -->
    </div>
    <!-- 语音 -->
    <!-- 不能用 if 否则点左边语音图标的时候不能获取麦克风权限 -->
    <div v-show="inputType === 'voice'" class="hx-flex-c-c hx-flex-j-s">
      <div
        class="left-icon my-icon-img"
        :style="{
          width: '28px',
          height: '28px',
          backgroundImage: `url(${require('/src/assets/icon/jp.png')})`,
        }"
        @click="iconClick('input')"
      >
        <!-- <van-icon name="music-o" />
         -->
      </div>
      <!-- <div class="btn left-input">按住说话</div> -->
      <AudioEnter
        :sendBtnLoading="sendBtnLoading"
        @onBaiduASR="onBaiduASR"
        ref="audioEnter"
      ></AudioEnter>
      <!-- <van-button class="btn left-input speak-btn" @click="isShow = true"
        >按住说话</van-button
      > -->
    </div>
    <!-- 打字 -->
    <div
      v-if="inputType === 'input'"
      class="hx-flex-c-c hx-flex-j-s hx-flex-a-s"
    >
<!--      v-if="!isIframe"-->
      <div
        class="left-icon my-icon-img"
        :style="{
          width: '28px',
          height: '28px',
          backgroundImage: `url(${require('/src/assets/icon/mkf.png')})`,
        }"
        v-show="showVoiceBtn"
        @click="iconClick('voice')"
      >
        <!-- <van-icon name="chat-o" /> -->
      </div>
      <div class="input-container left-input hx-flex-c-c hx-flex-a-s">
        <div class="custom_van_field_div">
          <van-field
            ref="myInput"
            class="my-input"
            type="textarea"
            rows="1"
            autosize

            maxlength="100"
            v-model="inputTextValue"
            :disabled="sendBtnLoading"
            placeholder=""
            enterkeyhint="send"
            @keyup.enter="sendMessage"
            @keydown.enter.prevent
          />
        </div>
        <!-- clearable清除控件 -->
        <!-- <div class="send-btn">发送</div> -->
        <!-- sendMsgClick()要加括号！！！ -->

      </div>
      <van-button class="send-btn" :loading="sendBtnLoading" @click="sendMsgClick()">发送</van-button>
      <van-button class="send-btn"  @click="TestBtnClick()" v-if="false">测试</van-button>
<!--      购物车图标 shoppingCarClick-->

      <div class="right-icon my-icon-img" :style="{width: '28px', height: '28px',backgroundImage: `url(${require('/src/assets/icon/icon_shop.png')})`,}"
        @click="shopChoose()"
      ></div>
    </div>
  </div>
</template>

<script>
import AudioEnter from "./AudioEnter.vue";
import { url_to_query } from '@/plugins/getUrlParam'
import { appletMark } from '@/api/app'

export default {
  name: "InputTool",
  components: { AudioEnter },
  inject: [
    "sendMsg",
    "sendMsgAnswerShowAndPlayEvent",
    "firstPlayAllMedia",
    "playAudio",
    "clickTestBtn",
  ],
  props: {
    // 小程序中传参的token，请求小程序api接口
    user_token: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      inputType: "hello", // hello , voice , input
      // inputTextValue: "你能做什么？",
      inputTextValue: "",
      sendBtnLoading: false,
      isDisabledBtn: false,
      isIframe: false,
      isShowShoppingCar: false,
      testValue: true,
      showVoiceBtn: true
    };
  },
  created() {
    // if (process.env.NODE_ENV !== "production") {
    //   this.iconClick("input");
    // }
  },
  mounted () {
    this.isIframe = window !== window.top;

    let isPC = false
    const platform = navigator.platform;
    if (platform.includes('Win') || platform.includes('Mac')) {
      console.log('平台环境为PC, Windows或Macintosh')
      isPC = true
    }  else {
      console.log('其他平台')
      isPC = false
    }

    let userAgent = navigator.userAgent.toLowerCase();
    console.log('userAgent', userAgent)

    if (isPC && userAgent.indexOf('miniprogram') !== -1) {
      // pc电脑微信小程序 则隐藏语音输入的入口
      this.showVoiceBtn = false
    }
  },
  beforeDestroy() {},
  methods: {
    setDisabledBtn(disable){
      this.isDisabledBtn = disable
    },
    onBaiduASR(data){
      console.log('input tool received onBaiduASR', data)
      this.$emit('onBaiduASR', data)
    },
    sendMessage(){
      this.sendMsgClick()
      this.$refs.myInput.blur() // 收起键盘
    },
    getRecorderStatus() {
      return this.$refs?.audioEnter?.isTouchstart;
    },
    cancelRecorder() {
      this.$refs?.audioEnter?.cancelBtn?.();
    },
    destroyRecorder() {
      this.$refs?.audioEnter?.close?.();
    },
    destroyRecorderNew() {
      this.$refs?.audioEnter?.destroyRecorderNew?.();
    },
    iconClick(data) {
      console.warn(`🚀 ~ file: InputTool.vue:132 ~ iconClick ~ data : `, data);
      if (this.sendBtnLoading) {
        this.$myToast({
          type: "fail",
          message: "正在生成中",
        });
        return;
      }
      if(this.showVoiceBtn) {
        this.inputType = data;
        if (this.inputType === "voice") {
          // this.$nextTick(() => {
          console.log("图标切换 调用 getPermission");
          this.$refs?.audioEnter?.getPermission?.();
          // });
        }
        if (this.inputType === "input") {
          // 如果正在录音时点了切换输入方式，就相当于手动取消
          this.cancelRecorder()
          this.destroyRecorderNew()
          console.warn(
            `🚀 ~ file: InputTool.vue:149 ~ iconClick ~ this.$refs?.audioEnter?.cancelBtn : `
          );
        }
      }

    },
    shoppingCarClick(){
      this.isShowShoppingCar = !this.isShowShoppingCar
      this.$emit('onClickShoppingCar', this.isShowShoppingCar)
    },
    shopChoose() {
      this.$emit('onClickShopChoose', true)
    },
    closeShoppingCar(){
      if(this.isShowShoppingCar){
        this.isShowShoppingCar = false
        this.$emit('onClickShoppingCar', false)
      }

    },
    // sendBtnClick() {
    //   this.sendBtnLoading = true;
    //   setTimeout(() => {
    //     this.sendBtnLoading = false;
    //   }, 1000 * 2);
    // },
    async helloClick() {
      // helloClick() {
      this.firstPlayAllMedia(); // 直接播放，默认biography已经放上去了
      this.inputType = "input";
      try {
        this.markUser()
      }catch (error){
        console.log('标记新老用户失败', error)
      }
      /* 走chart <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
      // this.sendBtnLoading = true;
      // this.sendMsg("你好")
      //   .then((result) => {
      //     // this.inputType = "voice";

      //     this.inputType = "input";
      //     // this.sendBtnLoading = false;
      //   })
      //   .catch((err) => {
      //     // this.sendBtnLoading = false;
      //   });
      /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */
      /* 走userInfo <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
      // const text = this.vuex_app_user_info?.biography || "";
      // if (!text) {
      //   this.$myToast({
      //     type: "fail",
      //     message: "没有介绍内容",
      //   });
      //   return;
      // }
      // try {
      //   // this.playAudio(
      //   //   "https://dl.stream.qqmusic.qq.com/C400000foxqB1Od6tF.m4a?guid=6247436119&vkey=0FBC85EFE958EED877628B7409DF89A678A50D66A956577A153F0AEA69B7D3DDF4223031823857516EFEFBC674576D71BE9E7B8D6793E37E&uin=&fromtag=120032"
      //   // );
      //   await this.sendMsgAnswerShowAndPlayEvent(text);
      //   // this.sendMsgAnswerShowAndPlayEvent(text);
      //   this.inputType = "input";
      // } catch (error) {
      //   console.error(
      //     `🚀 ~ file: InputTool.vue:143 ~ helloClick ~ error : `,
      //     error
      //   );
      // }
      /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */
      // setTimeout(() => {
      //   this.playAudio(
      //     "https://dl.stream.qqmusic.qq.com/C400000foxqB1Od6tF.m4a?guid=6247436119&vkey=0FBC85EFE958EED877628B7409DF89A678A50D66A956577A153F0AEA69B7D3DDF4223031823857516EFEFBC674576D71BE9E7B8D6793E37E&uin=&fromtag=120032"
      //   );

      //   this.inputType = "input";
      // }, 1000);
    },
    markUser(){
      console.log('enter markUser')
      if (this.user_token !== '') {
        appletMark(this.user_token).then( res => {
          console.log('markUser res', res)
        }).catch( error => {
          console.log('markUser error', error)
        })
      }
    },
    changeLoading(data = false) {
      this.sendBtnLoading = data;
    },
    TestBtnClick(){
      // 强制重新加载当前页面，忽略缓存
      // location.reload(true);// noah modify 20240330
      this.testValue = !this.testValue
      this.clickTestBtn()
    },
    sendInputText(text){
      console.log('enter sendInputText()123', text)
      this.inputTextValue = text
    },
    sendMsgClick(text = "") {
      console.warn(
        `🚀 ~ file: InputTool.vue:216 ~ sendMsgClick ~ text : `,
        text,
        this.inputTextValue
      );

      const inputTextValue = text || this.inputTextValue || "";
      if (this.sendBtnLoading == true) {
        this.$myToast({
          type: "fail",
          message: "正在生成中",
        });
        return;
      }
      if (!inputTextValue) {
        this.$myToast({
          type: "fail",
          message: "请先输入内容",
        });
        return;
      }
      // 自己控制，试加载过程而定，与语音播报不同步
      this.sendBtnLoading = true;

      this.sendMsg(inputTextValue, "sendMsgClick", true)
        .then((result) => {
          console.warn(
            "🚀 ~ file: InputTool.vue:247 ~ .then ~ result : ",
            result
          );
          this.inputTextValue = "";
          this.sendBtnLoading = false;
        })
        .catch((err) => {
          console.error(
            `🚀 ~ file: InputTool.vue:255 ~ sendMsgClick ~ err : `,
            err
          );
          this.sendBtnLoading = false;
          if (err.msg === '小程序用户未登录'){
            this.$vuex('jumpLoginMessage', '小程序用户凭据已过期,需要重新登录小程序。')
            this.$vuex('loginMiniDialog', true)
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.input-tool-container {
  height: calc(40px + env(safe-area-inset-bottom)); /*解决商品弹出层下方的问题*/
  // max-height: 40px;
  // padding: 12px 20px;
  padding: 12px 20px calc(12px + env(safe-area-inset-bottom) / 2) 20px;
  background: #252525;
  position: relative;
  z-index: 2999; // 10 弹窗商品层级问题
}
.btn {
  background: #363636;
  border-radius: 8px;
  margin: auto;
  text-align: center;
  padding: 8px;
  user-select: none;
  line-height: 24px;
  height: unset;
  border: none;
  color: #fff;
  cursor: pointer;
}
.btn:active {
  background: #555555;
}
.right-icon{
  margin: 6px 0 6px 10px ;
  cursor: pointer;
  font-size: 1.9em;
}
.left-icon {
  padding: 0 12px 0 0px;
  font-size: 1.9em;
  cursor: pointer;
  margin: 6px;
  margin-left: -6px;
}
.left-input {
  flex: 1;
}
.input-container {
  background: #363636;
  border-radius: 8px;
  margin: auto;
  text-align: left;
  padding: 4px;
}
.send-btn {
  border-radius: 6px;
  background: #5e5e5e;
  padding: 8px 14px;
  line-height: 1;
  border: none;
  color: #fff;
  height: 30px;
  min-width: 56px;
  align-self: center;
  margin-left: 4px;
}
.send-btn:active {
  background: #777;
}
.my-input.van-field {
  padding: 0;
  color: #fff;
  background: transparent;
  .van-field__body {
    background: #000;
  }
  ::v-deep .van-field__control {
    font-size: 16px;
    // background: #363636;
    color: #fff;
    border: none;
    outline: none;
    caret-color: #1edf41;
    line-height: 32px;
  }
}
.speak-btn {
  position: relative;
  z-index: 250;
}
.custom_van_field_div{
  flex: 1;
  padding-left: 6px;
}
</style>
